import { getReviewTop10, ResGetReviewTop10 } from '@/service/tour/main/getReviewTop10';
import { useQuery } from '@tanstack/react-query';
import { RQMainKey } from './RQMainKey';

export const useReviewTop10Query = () => {
  return useQuery<ResGetReviewTop10, Error, ResGetReviewTop10['result']>({
    queryKey: RQMainKey.reviewTop10,
    queryFn: getReviewTop10,
    select: (data) => data.result,
    staleTime: 1000 * 60 * 60 * 24,
    gcTime: 1000 * 60 * 60 * 24,
  });
};
